<template>
	<v-dialog 
	v-model="repover" 
	fullscreen 
	persistent 
	:overlay="false"
	transition="dialog-bottom-transition">
		<v-card height="100%">
			<v-toolbar color="primary" dark class="pa-1 d-flex justify-end align-center" max-height="50px">
				<!-- <v-progress-circular v-if="!sDataShow.length > 0" dark indeterminate></v-progress-circular> -->
				<div>
					<v-btn :disabled="sDataShow.length == 0" color="#FFFFFF"  class="no-uppercase" small  light outlined :loading="exportStatus " @click="onExportar" rounded> 
						<v-icon size="13px" left>mdi-export</v-icon>
						Exportar 
					</v-btn>
					<v-btn icon dark depressed class="ml-2" @click="$emit('click', false)"><v-icon>mdi-close</v-icon></v-btn>
				</div>
			</v-toolbar>
			<v-card-text class="contlist ma-0 pa-1">
				<div class="cont-total">
					<div v-if="sDataShow.length > 0" v-html="sDataShow" ></div>
					<div v-if="!sDataShow.length > 0" class="mx-auto d-flex justify-center align-center pa-2 tit-cargando">
						<fulfilling-bouncing-circle-spinner
							:animation-duration="4000"
							:size="40"
							color='#0E69B0'
						/>
						<h2 class="ma-0 ml-4">Cargando...</h2>
					</div>
					<v-skeleton-loader class="mt-n8" v-if="!sDataShow.length > 0" type="table-heading, table-thead, table-tbody, table-tbody"></v-skeleton-loader>
					<div v-if="sUbicacion.length > 0" width="100%"  id="printPage">		
						<MapaView 
							v-if="sUbicacion.length > 0" 
							:lat="sUbicacion.split(',')[0]"
							:lng="sUbicacion.split(',')[1]"
							:dimencion="{ancho:'100%', alto:'350px'}"
							:isDraggable="false">
						</MapaView>
					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
import MapaView from '@/components/Mapas/mapLocalizar.vue'
import html2canvas from 'html2canvas';
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

export default {
	components:{
		MapaView,
		FulfillingBouncingCircleSpinner,
	},
	name:"VistaReporte",
	model:{
		prop:'repover',
		event:'click'
	},
	props:{
		oParent: {
			type: Object,
		},
		sNameDetails: {
			type: String,
			default: ''
		},
		sNameTablePrin: {
			type: String,
			default: ''
		},
		repover:{
			type:Boolean,
			default:false
		},
		sIdCampo: { // Se recibe el nombre del campo de la llave principapara extracto el id valor 
			type: String,
			default: ''
		},
		aParametros: {
			type: Array,
			default: () => [] // Listado de string que continene parametros adicionales que se usan para realizar filtrado, este listado son campos existentes.
		},
		bSubdominioTemporal:{ //Indica que se activa puente con subdominio temporal
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			model: null,
			sDataShow: '',
			exportStatus: false,
			sUbicacion: '', 			// Debe llegar lat,lng
		}
	},
	async mounted() {
		await this.onGetInfo()
	},
	methods: {
		async onGetInfo() {
			const axiosInfo = await axiosServices.getConfiguration(`/build_correo/verdetalle/${this.sNameDetails}/${this.oParent[this.sIdCampo]}`, true )
			if(axiosInfo.sStatus === "success") {
				this.sDataShow = axiosInfo.aData.html
				this.sUbicacion = axiosInfo.aData.LatLng
			}
		},
		cardAction(val){
			this.ampliar = true
			this.ftampliada = val
		},
		async onExportar() {
			this.exportStatus = true

			const MapimgBase64 = await this.onExportMapa() 
			let oBody = {
					'MapimgBase64' : ''
				}
			if (MapimgBase64 !== null){
				oBody.MapimgBase64 = MapimgBase64
			}

			const axiosFile =  await axiosServices.postConfiguration(`/build_correo/pdfverdetalle/${this.sNameDetails}/${this.oParent[this.sIdCampo]}`, oBody, true )

			const sFile = await this.urltoFile('data:text/pdf;base64,' + axiosFile.aData.sFile, axiosFile.aData.sNombreArchivo,'text/pdf')
			const url = window.URL.createObjectURL(sFile);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', axiosFile.aData.sNombreArchivo); //or any other extension
			document.body.appendChild(link);
			link.click();

			this.$analytics.logEvent('Detalle-'+this.sNameDetails+'', { exportarDetalle:1}) //Analitics

			this.exportStatus = false
		},
		urltoFile(url, filename, mimeType){
			return (fetch(url)
					.then(function(res){return res.arrayBuffer();})
					.then(function(buf){return new File([buf], filename,{type:mimeType});})
			);
    },
		async onExportMapa(){  
			// como solo hay un elemento con id printPage no recorro nada 
			const  elements = document.querySelector("#printPage")
			if( elements !== null ){
				const  imagen = await html2canvas(elements, {
					scale: 2,
					useCORS: true,
					allowTaint: true
				})
				return imagen.toDataURL('image/png', 1.0)
			}

			return null 
		},

	},
	watch: {
		oParent (oNewValue) {
			if (oNewValue !== '') {
				this.onGetInfo()
			}
		}
	},
	computed: {
	},
}
</script>
<style lang="scss" scoped>
.close-btn{
	left: -35px;
	top: 2px;
	background: white!important;
	z-index:-1;
}
.v-navigation-drawer{
    overflow: initial;
}
@media screen and (max-width:600px) {
    .contendor-vista{
        font-size: 0.8em!important;
    }
}
.cont-general-print{
	font-size: 14px;
	line-height: 16px;
}
a {
	display: none !important;
}
.contlist{
	overflow: scroll;
	height: calc(100vh - 50px)!important;
}
.cont-total{
	width: 55%;
	height: auto;
	margin: 0 auto;
	color: #000000;
	border: solid 2px #DEDEDE;
	display: table;
	padding: 5px;
	@media screen and (max-width: 1200px) {
		width: 75%;
		padding: 5px;
	}
	@media screen and (max-width: 860px) {
		width:100%;
		border: none;
		padding: 0px;
	}
}
.tit-cargando{
	position: relative;
	z-index: 1;
}
</style>